var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classToast,attrs:{"id":_vm.toastId}},[_c('div',{staticClass:"toast-text"},[_vm._t("default")],2),_c('a',{staticClass:"toast-close",on:{"click":_vm.forceClose}},[_vm._v(" × ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }